<template>
    <div class="summary-card bg-white rounded-2xl mb-6 border border-[var(--bone)] shadow-[0px_1.4px_2.8px_0px_#0000000D] p-4">
        <div class="summary-rows">
            <div class="summary-row  flex items-center justify-between text-base text-[var(--charcoal-dark)]">
                <span>Ticket Cost</span>
                <span>{{ currencyFormat(globalTotal.subtotal) }}</span>
            </div>
            <div class="summary-row  flex items-center justify-between text-base text-[var(--charcoal-dark)]" v-if="globalTotal.discount > 0">
                <span>Discount</span>
                <span class="discount-amount">-{{ currencyFormat(globalTotal.discount) }}</span>
            </div>
            <div v-if="globalTotal.addons_total" class="summary-row  flex items-center justify-between text-base text-[var(--charcoal-dark)]">
                <span>Add-ons</span>
                <span>{{ currencyFormat(globalTotal.addons_total) }}</span>
            </div>
            <div class="summary-row  flex items-center justify-between text-base text-[var(--charcoal-dark)] mb-2">
                <span>Booking Fees</span>
                <span>{{ currencyFormat(Number(globalTotal.fees) + Number(globalTotal.addons_fee)) }}</span>
            </div>
            <div class="summary-row grand-total border-t border-[var(--bone)] pt-2 text-xl text-[var(--charcoal-dark)] font-bold flex justify-between">
                <span>Total Cost</span>
                <span>{{ currencyFormat(Number(globalTotal.total) + Number(globalTotal.addons_total) + Number(globalTotal.addons_fee)) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { formatCurrencyIntl } from '../../utils/currency';

export default {
    name: "ItemTotalSummary",
    props: ["globalTotal"],
    data: () => {
        return {}
    },
    methods: {
        currencyFormat(amount) {
            return formatCurrencyIntl(amount, this.$store.state.currency);
        },
    }
}
</script>